module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('loading'), _c('messageview'), _c('div', {
    staticClass: "nav-md",
    attrs: {
      "scroll": "auto"
    }
  }, [_c('div', {
    staticClass: "container body"
  }, [_c('div', {
    staticClass: "top_nav"
  }, [_c('div', {
    staticClass: "nav_menu"
  }, [_c('nav', [_c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/racooo_logo_indigo.png")
    }
  }), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle headermenu",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.$store.user.contractor_name + ' ' + _vm.$store.user.name) + "さん")]), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.user.admin == 1),
      expression: "$store.user.admin == 1"
    }]
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard/adminsettings"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "area": "true"
    }
  }, [_vm._v("　管理者設定")])])], 1), _vm._m(0), _c('li', [_c('router-link', {
    attrs: {
      "to": "/auth/login"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("　ログアウト")])])], 1)])])])])])])]), _c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "col-md-3 left_col"
  }, [_c('div', {
    staticClass: "left_col scroll-view"
  }, [_vm._m(1), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "main_menu_side hidden-print main_menu",
    attrs: {
      "id": "sidebar-menu"
    }
  }, [_c('div', {
    staticClass: "profile clearfix"
  }, [_c('div', {
    staticClass: "profile_info"
  }, [_c('span', [_vm._v("ようこそ")]), _c('p', [_vm._v(_vm._s(_vm.$store.user.name) + "さん")])])]), _c('div', {
    staticClass: "menu_section"
  }, [_c('ul', {
    staticClass: "nav side-menu"
  }, [_c('li', {
    class: {
      selected: _vm.selectedMessage
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard/information"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" メッセージ")])], 1), _c('li', {
    class: {
      selected: _vm.selectedForm
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard/forms"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" フォーム設定")])], 1)])])]), _c('div', {
    staticClass: "sidebar-footer hidden-small"
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard/usersettings",
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "個人設定"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('router-link', {
    attrs: {
      "to": "/dashboard/auth/login",
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "ログアウト"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])]), _c('router-view'), _c('footer-row')], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "area-hidden": "true"
    }
  }, [_vm._v("　ヘルプ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar nav_title",
    staticStyle: {
      "border": "0"
    }
  }, [_c('a', {
    staticClass: "site_title",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("Racooo")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1b8ff62","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Layout.vue
// module id = 615
// module chunks = 1